PopOverListas.$inject = [];
export default function PopOverListas() {
    return {
        restrict: 'E',
        controller: 'PopOverListasCtrl as pol',
        template: require('./popover-listas.html'),
        scope: {},
        bindToController: true
    };
}